module PortalLibs.Client.Option

open Fable.Core

let ofInfinite (value: float) =
  if JS.isFinite value then
    Some value
  else
    None